// packages import
import { Autocomplete, TextField } from '@mui/material'
import { FC, useContext } from 'react'

// others
import { BillingType } from '../../../../../generated'
import { FinalBillsContext } from '../../../../context/FinalBillsContext'

interface CaseTypeOption {
  value: BillingType
  label: string
}

const caseTypeOptions: CaseTypeOption[] = [
  { value: BillingType.Contingency, label: 'Contingency' },
  { value: BillingType.ContingencyHybrid, label: 'Contingency Hybrid' },
  { value: BillingType.FlatFee, label: 'Flat Fee' },
  { value: BillingType.Hourly, label: 'Hourly' },
  { value: BillingType.Hybrid, label: 'Hybrid' },
  { value: BillingType.ProBono, label: 'Pro Bono' }
]

const CaseTypeFilter: FC = () => {
  const { filters, setFilters } = useContext(FinalBillsContext)
  const selectedCaseType = caseTypeOptions.find(option => option.value === filters.caseType) || null

  const handleCaseTypeChange = (value: CaseTypeOption | null) => {
    setFilters({ caseType: value?.value })
  }

  return (
    <Autocomplete
      sx={{ minWidth: 150 }}
      options={caseTypeOptions}
      value={selectedCaseType}
      onChange={(_, value) => handleCaseTypeChange(value)}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => <TextField {...params} label="Matter Type" />}
    />
  )
}

export default CaseTypeFilter
